/* Sets the extras as being checked */
import { apiGet } from '../api';
import { EXTRA_CATEGORIES, MULTIPLE_ROOMS } from '../constants';

export const setIsCheckingExtras = (isCheckingExtras) => (dispatch) => {
  dispatch({ type: 'IS_CHECKING_EXTRAS', isCheckingExtras });
};

export const setExtrasAvailId = (availIdSelection, roomId) => (dispatch, getState) => {
  const {
    FIRST, SECOND, THIRD, FOURTH,
  } = MULTIPLE_ROOMS;
  const availId = {
    [FIRST]: null,
    [SECOND]: null,
    [THIRD]: null,
    [FOURTH]: null,
  };
  if (availIdSelection !== null) {
    const currentSelection = getState().extras.extrasAvailId;
    availId[FIRST] = roomId === FIRST ? availIdSelection : currentSelection[FIRST];
    availId[SECOND] = roomId === SECOND ? availIdSelection : currentSelection[SECOND];
    availId[THIRD] = roomId === THIRD ? availIdSelection : currentSelection[THIRD];
    availId[FOURTH] = roomId === FOURTH ? availIdSelection : currentSelection[FOURTH];
  }
  dispatch({ type: 'SET_EXTRAS_AVAIL_ID', availId });
};

export const setExtrasByRoomSelected = (extrasSelection, roomId) => (dispatch, getState) => {
  const {
    FIRST, SECOND, THIRD, FOURTH,
  } = MULTIPLE_ROOMS;
  const extrasByRoom = {
    [FIRST]: null,
    [SECOND]: null,
    [THIRD]: null,
    [FOURTH]: null,
  };

  if (extrasSelection !== null) {
    const currentSelection = getState().extras.extrasByRoomSelected;
    extrasByRoom[FIRST] = roomId === FIRST ? extrasSelection : currentSelection[FIRST];
    extrasByRoom[SECOND] = roomId === SECOND ? extrasSelection : currentSelection[SECOND];
    extrasByRoom[THIRD] = roomId === THIRD ? extrasSelection : currentSelection[THIRD];
    extrasByRoom[FOURTH] = roomId === FOURTH ? extrasSelection : currentSelection[FOURTH];
  }
  dispatch({ type: 'SET_EXTRAS_BY_ROOM_SELECTED', extrasByRoom });
};

export const checkExtrasByRoom = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { bookingFormState, booking } = state;
  const {
    roomCode, rateCode, boardCode, distribution, roomId, isLoyalty,
  } = payload;
  dispatch(setIsCheckingExtras(true));
  const { adults, childs, infants } = distribution;
  const params = [
    `${process.env[`${bookingFormState.chain}_CHAIN`]}`,
    bookingFormState.sessionId,
    booking.hotel.code,
    bookingFormState.checkIn,
    bookingFormState.checkOut,
    roomCode,
    adults,
    childs,
    infants,
    boardCode,
    rateCode,
    isLoyalty,
  ];
  const result = {
    success: false,
    extrasAvailable: false,
  };
  const url = `api-pb/availability/extras/${params.join('/')}/`;
  await apiGet(url).then((response) => {
    if (response) {
      const { extras, error, avail_id } = response;
      if (error === '00' && extras.length > 0) { // 00 means no error code, everything went as expected
        dispatch(setExtrasAvailId(avail_id, roomId));
        extras.sort((extra) => (extra.category === EXTRA_CATEGORIES.RETREAT ? -1 : 1));
        dispatch(setExtrasByRoomSelected(extras, roomId));
        result.success = true;
        result.extrasAvailable = true;
      } else {
        result.errorCode = `DINGUS: ${error}`;
      }
    }
  });
  dispatch(setIsCheckingExtras(false));
  return result;
};
